<template>
    <div>
        <el-card class="content-card">
            <!-- Header -->
            <div class="section-header">
                <h4>Addresses</h4>
                <a href="#" class="add-address" @click="dialogVisible = true">Add New Address</a>
            </div>
            <el-divider></el-divider>

            <!-- Address Table -->
            <el-table :data="addressList" style="width: 100%">
                <el-table-column prop="type" label="Type"></el-table-column>
                <el-table-column prop="line_1" label="Address"></el-table-column>
                <el-table-column prop="stateName" label="State"></el-table-column>
                <el-table-column prop="countryName" label="Country"></el-table-column>
                <el-table-column prop="postal_code" label="Postal Code"></el-table-column>
                <el-table-column prop="created_at" label="Creation Time"></el-table-column>

                <!-- Actions -->
                <el-table-column label="Actions" width="100">
                    <template slot-scope="{ row, $index }">
                        <el-tooltip content="Edit">
                            <i class="el-icon-edit action-icon" @click="editAddress(row)"></i>
                        </el-tooltip>
                        <el-tooltip content="Delete">
                            <i class="el-icon-delete action-icon delete-icon" @click="confirmDelete($index)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- Add/Edit Address Modal -->
        <AddAddressModal :visible.sync="dialogVisible" :existingAddress="editingAddress"
            @addressCreated="handleNewAddress" />

        <!-- Delete Confirmation Modal -->
        <el-dialog :visible.sync="deleteDialogVisible" width="400px" class="delete-dialog" :before-close="cancelDelete">
            <div class="delete-content">
                <i class="el-icon-warning warning-icon"></i>
                <div>
                    <h3>Delete</h3>
                    <p>
                        Are you sure you want to remove <strong>{{ deleteTarget?.name }}, {{ deleteTarget?.line_1
                        }}</strong>?
                        This will also remove its associated data. This can't be undone.
                    </p>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelDelete">Cancel</el-button>
                <el-button type="danger" @click="deleteAddress">Confirm</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import AddAddressModal from "./AddAddressModal.vue";
import { getAddressesList, createAddress, updateAddress, deleteAddress } from "@/api/delivery";
import axios from "axios";
export default {
    name: "AddressManager",
    components: { AddAddressModal },
    data() {
        return {
            dialogVisible: false,
            deleteDialogVisible: false,
            editingAddress: null, // Address to edit
            deleteTarget: null,
            deleteIndex: null,
            addressList: [], // List of addresses
            countries: [], // List of countries with code and name
            states: [], // List of states with code and name
        };
    },
    created() {
        this.fetchCountryStateData();
        this.addressesListApi(); // Fetch the list of addresses on component creation
    },
    methods: {
        async addressesListApi() {
            try {
                const res = await getAddressesList();
                if (res.success) {
                    this.fetchCountryStateData()
                    this.addressList = res.body.items.map(item => ({
                        ...item,
                        countryName: this.getCountryName(item.country),
                        stateName: this.getStateName(item.country, item.state),
                    }));
                }
            } catch (error) {
                console.error("Error fetching address list:", error);
           
            }
        },

        async fetchCountryStateData() {
            try {
                const res = await axios.get("https://lazidev.futong.online/json/country-state.json");
                const countryData = res.data.data;

                this.countries = countryData.map(country => ({
                    name: country.name,
                    code: country.code,
                }));

                this.states = countryData.flatMap(country =>
                    country.states.map(state => ({
                        name: state.name,
                        code: state.code,
                        countryCode: country.code,
                    }))
                );
            } catch (error) {
                console.error("Error fetching country and state data:", error);

            }
        },

        getCountryName(countryCode) {
            const country = this.countries.find(country => country.code === countryCode);
            return country ? country.name : countryCode;
        },

        getStateName(countryCode, stateCode) {
            const state = this.states.find(state => state.code === stateCode && state.countryCode === countryCode);
            return state ? state.name : stateCode;
        },

        // When editing or creating a new address
       async handleNewAddress(newAddress) {
            try {
                if (this.editingAddress) {
                    // 更新地址
                    await updateAddress({ ...newAddress, id: this.editingAddress.id });
                    Object.assign(this.editingAddress, newAddress);
                    this.$message.success("Address updated successfully!");
                } else {
                    // 新增地址
                    await createAddress(newAddress);
                    this.addressesListApi()
                    // this.addressList.push(newAddress);
                    this.$message.success("New address added!");
                }
            } catch (error) {
                console.error("Error handling address:", error);

            }

            this.editingAddress = null;
            this.dialogVisible = false;
        },

        resetForm() {
            this.editingAddress = null;  // 清空编辑地址
            this.dialogVisible = true;   // 打开弹窗
        },
        // Edit the selected address
        editAddress(address) {
            this.editingAddress = { ...address };
            this.dialogVisible = true;
        },

        confirmDelete(index) {
            this.deleteIndex = index;
            this.deleteTarget = this.addressList[index];
            this.deleteDialogVisible = true;
        },

        cancelDelete() {
            this.deleteDialogVisible = false;
            this.deleteTarget = null;
            this.deleteIndex = null;
        },

        // Delete the address
        async deleteAddress() {
            if (this.deleteIndex !== null) {
                try {
                    await deleteAddress(this.deleteTarget.id);
                    this.addressList.splice(this.deleteIndex, 1);
                    this.$message.success("Address deleted!");
                } catch (error) {
                    console.error("Error deleting address:", error);

                }
            }
            this.cancelDelete();
        },
    },
};
</script>




<style scoped>
/* Card */
.content-card {
    padding: 20px;
    border-radius: 8px;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Header */
.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.section-header h4 {
    font-size: 18px;
    font-weight: bold;
}

.add-address {
    font-size: 14px;
    color: #409eff;
    text-decoration: none;
}

.add-address:hover {
    text-decoration: underline;
}

/* Table */
.el-table th {
    font-weight: bold;
    color: #666;
    text-align: left;
}

.el-table td {
    color: #333;
}

/* Primary Address Star */
.primary-star {
    color: #f7ba2a;
    margin-left: 5px;
}

/* Action Icons */
.action-icon {
    font-size: 18px;
    margin-right: 10px;
    color: #606266;
    cursor: pointer;
}

.action-icon:hover {
    color: #409eff;
}

.delete-icon {
    color: #f56c6c;
}

.delete-icon:hover {
    color: #ff0000;
}

/* Delete Dialog */
.delete-dialog {
    border-radius: 8px;
}

.delete-content {
    display: flex;
    align-items: center;
    gap: 15px;
}

.warning-icon {
    font-size: 40px;
    color: #f56c6c;
}

.dialog-footer {
    display: flex;
    justify-content: flex-end;
}
</style>
